import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ContactForm from "../components/ContactUs/ContactForm";
import Footer from "../components/_App/Footer";
import Header from "../components/_App/Header";
import apiClient, { webServiceClient } from "../data/apiClient";
import { FOOTER_QUERY } from "../data/pageQuery";

const Contact = ({ seo, footer, menu }) => {
  return (
    <>
      <Header {...menu} />
      {/* <GoogleReCaptchaProvider
        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      > */}
        <ContactForm />
      {/* </GoogleReCaptchaProvider> */}
      <Footer {...footer} />
    </>
  );
};

export async function getStaticProps() {
  const api = webServiceClient();
  const { data } = await(await apiClient()).query({
    query: FOOTER_QUERY,
    variables: {},
    fetchPolicy: "cache-first",
  });

  const {
    queryFooterContents: footerContents,
    queryMenuContents: menuContents,
  } = data;

  const footerContent =
    footerContents[0] != null ? footerContents[0].flatData : [];
  const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

  return {
    props: {
      footer: footerContent,
      menu: menuContent,
      seo: { title: "Ryco Filters | Contact Us" },
    },
    revalidate: 30 * 60,
  };
}

export default Contact;
